// ID: 211 TO 240 CLASSIC
// ID: 241 TO 270 SMART

const WatchList =
{
    WatchApiCategory: "AllWatches",
    AllWatchData: [
        {
            id: 211,
            brand: "EXTRI",
            name: "Analog Watch - For Men X6057-G",
            main_img:
                "https://i.postimg.cc/HLYxrBMg/5.jpg",
            item_img_1:
                "https://i.postimg.cc/ry3Kf1B1/1.jpg",
            item_img_2:
                "https://i.postimg.cc/YCf02JhR/3.jpg",
            item_img_3:
                "https://i.postimg.cc/fTdkp3s6/4.jpg",
            item_img_4:
                "https://i.postimg.cc/L5c5hStC/2.jpg",
            price: 2840,
            old_price: "₹8499",
            price_off: "66% Off",
            rating: 3.9,
            // qty: 1,

        },
        {
            id: 212,
            brand: "Carlington",
            name: "Mesh Strap Water Resistant Analog Watch - For Women CT2007",
            main_img:
                "https://i.postimg.cc/SRmLxw4p/1.jpg",
            item_img_1:
                "https://i.postimg.cc/Vv4qrDs0/2.jpg",
            item_img_2:
                "https://i.postimg.cc/j5HQKRGX/3.jpg",
            item_img_3:
                "https://i.postimg.cc/k43Fk2hG/4.jpg",
            item_img_4:
                "https://i.postimg.cc/YCv6065j/5.jpg",
            price: 919,
            old_price: "₹4999",
            price_off: "81% Off",
            rating: 3.4,
            // qty: 1,
        },
        {
            id: 213,
            brand: "Espoir ",
            name: "Day And Date Functioning High Quality Analog Watch - For Men ES2615",
            main_img:
                "https://i.postimg.cc/Wb6h6XZh/1.jpg",
            item_img_1:
                "https://i.postimg.cc/8PV76qj2/2.jpg",
            item_img_2:
                "https://i.postimg.cc/GpN2hfWS/3.jpg",
            item_img_3:
                "https://i.postimg.cc/fR8y1yBs/4.jpg",
            item_img_4:
                "https://i.postimg.cc/rpzsTTPr/5.jpg",
            price: 315,
            old_price: "₹1995",
            price_off: "84% Off",
            rating: 3.8,
            // qty: 1,
        },
        {
            id: 214,
            brand: "Curren",
            name: "Analog Watch - For Men New Stylist Royal",
            main_img:
                "https://i.postimg.cc/WbKGFsBs/2.jpg",
            item_img_1:
                "https://i.postimg.cc/4x9zprGV/1.jpg",
            item_img_2:
                "https://i.postimg.cc/KYhtfJcV/3.jpg",
            item_img_3:
                "https://i.postimg.cc/hG8T5TfG/4.jpg",
            item_img_4:
                "https://i.postimg.cc/JnPJ183V/5.jpg",
            price: 457,
            old_price: "₹1599",
            price_off: "71% Off",
            rating: 3.8,
            // qty: 1,

        },
        {
            id: 215,
            brand: "Fastrack",
            name: "Uptown Retreat Analog Watch - For Women 6260WL02",
            main_img:
                "https://i.postimg.cc/HsN8L3fK/1.jpg",
            item_img_1:
                "https://i.postimg.cc/wv97rrmt/2.jpg",
            item_img_2:
                "https://i.postimg.cc/LsKqt543/3.jpg",
            item_img_3:
                "https://i.postimg.cc/9QqRwZ2f/4.jpg",
            item_img_4:
                "https://i.postimg.cc/W3Shc7G5/5.jpg",
            price: 1557,
            old_price: "₹2595",
            price_off: "40% Off",
            rating: 4.2,
            // qty: 1,
        },
        {
            id: 216,
            brand: "LIMESTONE",
            name: "Mesh Strap All Black Avatar Day and Date Functioning Quartz Analog Watch - For Men LS2917",
            main_img:
                "https://i.postimg.cc/4y2vsckT/1.jpg",
            item_img_1:
                "https://i.postimg.cc/PJ5bg474/2.jpg",
            item_img_2:
                "https://i.postimg.cc/DfxPq9WY/3.jpg",
            item_img_3:
                "https://i.postimg.cc/3JWC9tmr/4.jpg",
            item_img_4:
                "https://i.postimg.cc/26fLd6Gf/original-imaghny5mmjg6yht.jpg",
            price: 280,
            old_price: "₹2999",
            price_off: "90% Off",
            rating: 4.3,
            // qty: 1,
        },

        {
            id: 217,
            brand: "Fastrack",
            name: "Analog Watch - For Women 6249SM04",
            main_img:
                "https://i.postimg.cc/CLN2WP63/2.jpg",
            item_img_1:
                "https://i.postimg.cc/Vkkh1qxd/1.jpg",
            item_img_2:
                "https://i.postimg.cc/htZ5GJnM/3.jpg",
            item_img_3:
                "https://i.postimg.cc/wBtbR6Tz/4.jpg",
            item_img_4:
                "https://i.postimg.cc/Bvd7xdXK/5.jpg",
            price: 1257,
            old_price: "₹2095",
            price_off: "40% Off",
            rating: 3.9,
            // qty: 1,
        },
        {
            id: 218,
            brand: "TIMEX",
            name: "Analog Watch - For Women TWEL107SMU06",
            main_img:
                "https://i.postimg.cc/HLYxrBMg/5.jpg",
            item_img_1:
                "https://i.postimg.cc/ry3Kf1B1/1.jpg",
            item_img_2:
                "https://i.postimg.cc/YCf02JhR/3.jpg",
            item_img_3:
                "https://i.postimg.cc/fTdkp3s6/4.jpg",
            item_img_4:
                "https://i.postimg.cc/L5c5hStC/2.jpg",
            price: 1321,
            old_price: "₹2995",
            price_off: "55% Off",
            rating: 3.7,
            // qty: 1,
        },
        {
            id: 219,
            brand: "VAN HEUSEN",
            name: "Analog Watch - For Women VH000008D",
            main_img:
                "https://i.postimg.cc/Bnd79r4n/1.jpg",
            item_img_1:
                "https://i.postimg.cc/3NJnF7Cn/3.jpg",
            item_img_2:
                "https://i.postimg.cc/Z59sQbkQ/2.jpg",
            item_img_3:
                "https://i.postimg.cc/pTv0yK9N/4.jpg",
            item_img_4:
                "https://i.postimg.cc/d0rHq5Vm/5.jpg",
            price: 1310,
            old_price: "₹2999",
            price_off: "56% Off",
            rating: 4.2,
            // qty: 1,
        },

        {
            id: 220,
            brand: "SKMEI",
            name: "Sports Analog-Digital Watch - For Men Gmarks -1327",
            main_img:
                "https://i.postimg.cc/xTsLBhLN/1.jpg",
            item_img_1:
                "https://i.postimg.cc/yY6FQs3z/2.jpg",
            item_img_2:
                "https://i.postimg.cc/D0nqKKCL/3.jpg",
            item_img_3:
                "https://i.postimg.cc/fWfcfJLK/4.jpg",
            item_img_4:
                "https://i.postimg.cc/j2cyxk99/5.jpg",
            price: 381,
            old_price: "₹1999",
            price_off: "80% Off",
            rating: 4.2,
            // qty: 1,
        },
        // {
        //     id: 221,
        //     brand: "",
        //     name: "",
        //     main_img:
        //         "",
        //     item_img_1:
        //         "",
        //     item_img_2:
        //         "",
        //     item_img_3:
        //         "",
        //     item_img_4:
        //         "",
        //     price: ,
        //     Stock: "",
        //     price_off: "",
        //     rating: 2.9,
        // qty: 1,
        // },

    ]
}

export default WatchList;